export abstract class LuTypeaheadChip {
	data: any;
	close: () => void;
	index: number;
	chipsLength: number;

	constructor() {}
}
